var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _c(
      "svg",
      {
        staticStyle: { "enable-background": "new 0 0 512 512" },
        attrs: {
          fill: "white",
          x: "0px",
          y: "0px",
          width: "30px",
          height: "30px",
          viewBox: "0 0 512 512",
        },
      },
      [
        _c("path", {
          attrs: {
            d: "M389.433 72.762H19.611C8.797 72.762 0 81.558 0 92.374V316.67c0 10.818 8.797 19.611 19.611 19.611h369.822c10.812 0 19.609-8.793 19.609-19.611V92.374c0-10.816-8.796-19.612-19.609-19.612zm2.801 243.908a2.8 2.8 0 0 1-2.801 2.802H19.611a2.798 2.798 0 0 1-2.802-2.802V92.374a2.804 2.804 0 0 1 2.802-2.802h369.822a2.806 2.806 0 0 1 2.801 2.802V316.67z",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }